import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromUserPreference from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { UserPreferenceEffects } from './effects/user-preference.effects';



@NgModule({
  imports: [
    StoreModule.forFeature(
      fromUserPreference.userPreferenceKey,
      fromUserPreference.reducers,
    ),
    EffectsModule.forFeature([
      UserPreferenceEffects
    ])
  ]
})
export class UserPreferenceModule { }
